export const PROGRAM_STATUS = {
  REGISTRATION_OPEN: 'REGISTRATION_OPEN',
  REGISTRATION_CLOSED: 'REGISTRATION_CLOSED',
  PREQUALIFICATION_CLOSED: 'PREQUALIFICATION_CLOSED',
  PREQUALIFICATION_OPEN: 'PREQUALIFICATION_OPEN'
}

export const getReadableProgramStatus = programStatus => {
  switch (programStatus) {
    case PROGRAM_STATUS.REGISTRATION_OPEN:
      return 'Regisztráció nyitva'
    case PROGRAM_STATUS.REGISTRATION_CLOSED:
      return 'Regisztráció zárva'
    case PROGRAM_STATUS.PREQUALIFICATION_CLOSED:
      return 'Előminősítés zárva'
    case PROGRAM_STATUS.PREQUALIFICATION_OPEN:
      return 'Előminősítés nyitva'
  }
}
